import { Location } from 'history'

type LocationProps = Pick<Location, 'hash' | 'pathname' | 'search'>

export const getLoginRedirectUrl = (
  { hash, pathname, search }: LocationProps,
  app = ''
) =>
  search.includes('redirect')
    ? `${app}/login${search}`
    : `${app}/login?redirect=${pathname}${search.replace('?', '&')}${hash}`

export const getSearchRedirectUrl = ({
  hash,
  pathname,
  search,
}: LocationProps) =>
  search.includes('redirect')
    ? search
    : `?redirect=${pathname}${search.replace('?', '&')}${hash}`
